export const transactionDataQueryKey = (transactionId: string): [string, string] => [
  'transactionData',
  transactionId
];

